// extracted by mini-css-extract-plugin
module.exports = {"section":"IntegrationsHero_section__81VSH","subtitle":"IntegrationsHero_subtitle__EvsYq"};